import { useAuthStore } from '@/store/authStore';
import { hasStoredAuthTokens } from '@/utils/session';

/**
 * Single source of truth for "should the UI render in authenticated layout."
 * True when verified-authenticated, OR when stored tokens exist and auth is still
 * being verified. Header, Layout, and any future auth-gated chrome should call this
 * so the predicate doesn't drift across siblings (which causes layout shift on flip).
 */
export function useShowAuthenticatedLayout(): boolean {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated || hasStoredAuthTokens();
}
